// extracted by mini-css-extract-plugin
export var ctaBanner = "EndpointWidget-module--ctaBanner--f0212";
export var endpointWidget = "EndpointWidget-module--endpointWidget--cd69c";
export var hidden = "EndpointWidget-module--hidden--6ddbb";